module.exports = __webpack_public_path__ + "img/ederra.441a4738.png";